import { WebappEnv } from '@/entities/webapp-env';
import { LookerEnv } from '@/types/looker-env';

import { UnreachableCaseError } from './errors/unreachable-case-error';

export function lookerEnvFromWebappEnv(webappEnv: WebappEnv): LookerEnv {
  switch (webappEnv) {
    case WebappEnv.LOCAL:
    case WebappEnv.SANDBOX:
    case WebappEnv.STAGING: {
      return LookerEnv.STAGING;
    }
    case WebappEnv.PRODUCTION: {
      return LookerEnv.PRODUCTION;
    }
    default: {
      throw new UnreachableCaseError(webappEnv);
    }
  }
}
